import { backoffRetrier } from "../../lib/utils";
/**
 * Represents a deposit for the tBTC protocol.
 */
export default class Deposit {
    #tbtcApi;
    #tbtcSdkDeposit;
    #revealData;
    constructor(tbtcApi, tbtcSdkDeposit, revealData) {
        this.#tbtcApi = tbtcApi;
        this.#tbtcSdkDeposit = tbtcSdkDeposit;
        this.#revealData = revealData;
    }
    /**
     * Retrieves the Bitcoin address corresponding to this deposit.
     * This address should be used as the destination for sending BTC to fund the
     * deposit.
     * @returns The Bitcoin address corresponding to this deposit.
     */
    async getBitcoinAddress() {
        return this.#tbtcSdkDeposit.getBitcoinAddress();
    }
    /**
     * Retrieves the receipt corresponding to the tbtc deposit.
     * @returns The deposit receipt.
     */
    getReceipt() {
        return this.#tbtcSdkDeposit.getReceipt();
    }
    /**
     * Waits for the deposit to be funded with BTC.
     * @param options The retry options for waiting.
     * @throws Error if the deposit is not funded within the specified retries.
     */
    async waitForFunding(options) {
        await backoffRetrier(options.retries, options.backoffStepMs)(async () => {
            const utxos = await this.#tbtcSdkDeposit.detectFunding();
            if (utxos.length === 0)
                throw new Error("Deposit not funded yet");
        });
    }
    /**
     * Creates a bitcoin deposit on the tBTC API backend side.
     * This function should be called after the bitcoin transaction is made to the
     * deposit address.
     * @throws Error if the deposit creation fails on the tBTC API side or the bitcoin
     *         funding transaction couldn't be found.
     * @returns The tBTC API deposit ID.
     */
    async createDeposit() {
        const { revealInfo, metadata } = this.#revealData;
        const { depositOwner, referral } = metadata;
        const createBitcoinDepositData = {
            depositReceipt: revealInfo,
            depositOwner,
            referral,
        };
        const response = await this.#tbtcApi.createDeposit(createBitcoinDepositData);
        // TODO: Determine return type based on dApp needs, possibly calculate depositKey.
        return response.depositId;
    }
}
//# sourceMappingURL=Deposit.js.map